import { TGetMeDto } from "@/api/services/main/auth/dtos/get-me.dto";
import { Button } from "@/components/elements/Button";
import { InnerBox } from "@/components/elements/InnerBox";
import { ReadonlyField } from "@/features/user-setting/components/detail/ReadonlyField";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type TAccountBasicInfoSectionProps = {
  me: TGetMeDto;
  pendingEmail?: string | null;
  onCancelEmailChange?: () => void;
};

export const AccountBasicInfoSection: FC<TAccountBasicInfoSectionProps> = ({ me, pendingEmail, onCancelEmailChange }) => {
  const navigate = useNavigate();

  const emailValue = pendingEmail ? (
    <Stack gap="4px">
      <Typography variant="body14Semi" color={text.primary}>
        {me.email}
      </Typography>
      <Typography variant="body14Semi" color={text.primary}>
        {pendingEmail} (確認中)
      </Typography>
    </Stack>
  ) : (
    me.email
  );

  return (
    <InnerBox title="アカウント基本情報" padding="24px">
      <Stack direction="row" gap="24px" alignItems="flex-start" flexWrap="wrap">
        <Stack direction="row" gap="48px" flex={1} minWidth={0} flexWrap="wrap">
          <ReadonlyField label="氏名" value={me.fullName} />
          <ReadonlyField label="メールアドレス" value={emailValue} />
        </Stack>
        <Stack gap="12px" minWidth="160px">
          <Button fullWidth size="sm" variant="secondary" onClick={() => navigate(AppRoutes.userSettingChangeEmail)}>
            メールアドレス変更
          </Button>
          {pendingEmail && (
            <Button fullWidth size="sm" variant="ghost" onClick={onCancelEmailChange}>
              変更をキャンセル
            </Button>
          )}
        </Stack>
      </Stack>
    </InnerBox>
  );
};
